import { DateTime, IANAZone } from "luxon";

/**
 * Builds and downloads a CSV with the failed orders from a WMS massive-dispatch
 * bulk upload response. No-op when there are no error results.
 *
 * @param {Array<{trackingId: string, status: string, message: string}>} results
 */
export const downloadBulkUploadErrorsCsv = (results) => {
  if (!Array.isArray(results)) return;

  const errorOrders = results.filter((result) => result.status === "error");
  if (errorOrders.length === 0) return;

  const bom = "﻿";
  const csvData = errorOrders
    .map((order) => `${order.trackingId.trim()};${order.message}`)
    .join("\n");
  const csvContent = bom + csvData;
  const fileName =
    DateTime.now().setZone(new IANAZone("America/Bogota")).toFormat("yyyy-MM-dd") +
    "-detailBulkUploadOrdersWMSErrors.csv";

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download === undefined) return;

  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
